import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, gbp } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          const { data: b } = await api.get(`/bookings/${data.booking_id}`);
          setBooking(b);
          return;
        }
        if (tries++ < 8) setTimeout(poll, 1500); else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [params]);

  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center">
      {status === "checking" && (<><Loader2 className="w-12 h-12 animate-spin text-[#0B3C5D] mx-auto" /><p className="mt-4 text-slate-600">Confirming your payment…</p></>)}
      {status === "paid" && (
        <div data-testid="payment-success" className="bg-white rounded-3xl border border-slate-200 p-10">
          <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto" />
          <h1 className="font-display text-3xl font-bold text-slate-900 mt-4">Booking confirmed!</h1>
          {booking && (
            <div className="mt-6 text-left bg-slate-50 rounded-xl p-5 border border-slate-200">
              <p className="text-sm text-slate-500">Reference</p>
              <p className="font-display text-xl font-bold text-[#0B3C5D]">{booking.reference}</p>
              <div className="mt-3 text-sm text-slate-600"><p>{booking.item_title}</p><p className="font-semibold mt-1">Paid: {gbp(booking.amount)}</p></div>
            </div>
          )}
          <p className="text-slate-500 text-sm mt-5">A confirmation has been sent to your email. Our team will follow up with your travel documents.</p>
          <Link to="/"><Button className="mt-6 rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold px-8">Back to home</Button></Link>
        </div>
      )}
      {(status === "pending" || status === "error") && (
        <div className="bg-white rounded-3xl border border-slate-200 p-10">
          <XCircle className="w-16 h-16 text-amber-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold text-slate-900 mt-4">Payment {status === "pending" ? "processing" : "not confirmed"}</h1>
          <p className="text-slate-500 text-sm mt-3">If you were charged, your booking will confirm shortly. Contact us with any questions.</p>
          <Link to="/"><Button className="mt-6 rounded-full bg-[#0B3C5D] text-white px-8">Back to home</Button></Link>
        </div>
      )}
    </div>
  );
}
